import React from "react";

const Mission = () => {
  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center max-w-5xl mx-auto">
          <p className="text-2xl md:text-4xl font-light leading-relaxed">
            Tax Solutions AS is committed to delivering excellence across all
            services regardless of the nature of your business. Trusting us is
            the key to your financial success.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Mission;
